const mapTest = {

    loginORregister: {

        registerButton: "register-button",

        registerEmail: "email",

        registerPhone: "phone",

        registerUserName: "name",

        registerPassword: "pswd",

        registerConfirmPassword: "pswd2",

        acceptTermsCheckbox: "acceptTerms",

        createAccountButton: "register-button",

        loginEmail: "email",

        loginPassword: "password",

        loginButton: "login-button",
    },

    createBranch: {

        createBranchButton: 'create-branch-button',

        info: {
            fields: {
                inputBranchName: "createBranch-information-fields-branch-name",

                inputBranchEmail: "createBranch-information-fields-branch-email",

                inputBranchPhone: "createBranch-information-fields-branch-phone",

                inputFancyName: "createBranch-information-fields-branch-fancy-name",

                inputStateRegistry: "createBranch-information-fields-branch-state-registry",

                inputBranchCrt: "createBranch-information-fields-branch-crt",

                inputBranchDocument: "person-input-doc",

                inputBranchCnae: "createBranch-information-fields-branch-cnae",
            }
        },

        address: {
            fields: {

                inputPostalCode: "createBranch-address-fields-postal-code",
            }
        }

    },

    sidebar: {

        home: "sidebar-home",
        pos: "sidebar-pos",
        products: {
            index: "sidebar-products",
            createProduct: "sidebar-products-create-product",
            listProduct: "sidebar-products-list-product",
            categoryProduct: "sidebar-products-product-category",
            providerProduct: "sidebar-products-product-providers",
            icmsProduct: "sidebar-products-icms",
            ipiProduct: "sidebar-products-ipi"
        },
        clients: {
            index: "sidebar-clients",
            createClient: "sidebar-clients-create",
            listClient: "sidebar-clients-list"
        },
        salesPerson:{
            index: "sidebar-salesperson",
            createSalesPerson: "sidebar-salesperson-create-salesperson",
            listSalesPerson: "sidebar-salesperson-list-salesperson"
        },
        report: {
            index: "sidebar-report",
            sales: "sidebar-report-sales"
        },
        stock: {
            index: "sidebar-stock",
            info: "sidebar-stock-information",
            movimentation: "sidebar-stock-movimentation"
        },
        nfe: {
            index: "sidebar-nfe",
            emit: "sidebar-nfe-emit-nfe",
            list: "sidebar-nfe-list-nfe",
            transporters: "sidebar-nfe-transporters",
            settings: "sidebar-nfe-settings"
        },
        nfce: {
            index: "sidebar-nfce",
            settings: "sidebar-nfce-settings"
        },
        nfse: {
            index: "sidebar-nfse",
            emit: "sidebar-nfse-emit-nfse",
            list: "sidebar-nfse-list-nfse",
            settings: "sidebar-nfse-settings",
            
        },
        digitalCertificate: "sidebar-digital-certificate",
        settings: "sidebar-settings"
    },

    createProduct: {
        inputSearchBarcode: "create-input-search-barcode",
        buttonSearchBarcode: "create-product-button-search-barcode",

        inputProductName: "create-product-input-name",
        inputProductCode: "create-product-input-code",
        inputProductPrice: "create-product-input-price",
        inputProductCost: "create-product-input-cost",

        cancelButton: "create-product-button-exit-page",
        createButton: "create-product-button-create-product",
        unit: {
            select: "create-product-select-unit",
            buttonCreate: "create-product-button-create-unit",
            inputName: "create-product-input-create-unit-name",
            buttonSave: "create-product-input-create-unit-save",
            buttonClose: "create-product-input-create-unit-close",
        },
        category: {
            select: "create-product-select-category",
            buttonCreate: "create-product-button-create-category",
            inputName: "create-product-input-create-category-name",
            buttonSave: "create-product-input-create-category-save",
            buttonClose: "create-product-input-create-category-close",
        },

        ncm: {
            input: "create-product-input-ncm",
            buttonFindNcm: "create-product-button-find-ncm",
        },

        icms: {
            select: 'create-product-select-icms',
            buttonCreate: 'create-product-button-create-icms'
        },

        cfop: {
            input: "create-product-input-cfop",
            buttonSelect5101: "create-product-select-5101",
            buttonSelect5102: "create-product-select-5102"
        },

        ipi: {
            select: 'create-product-select-ipi',
            buttonCreate: 'create-product-button-create-ipi'
        }

    },

    nfeFilter: {

        applyFiltersButton: "nfe-filter-apply-filters",

        number: {
            input: "nfe-filter-number-input"
        },
        status: {
            input: "nfe-filter-status-select"
        },
        emissionDateInitial: {
            input: "nfe-filter-initial-emission-date-input"
        },
        emissionDateFinal: {
            input: "nfe-filter-final-emission-date-input"
        },
        showLatest: {
            input: "nfe-filter-showing-latest"
        }
        
    },

    createClient: {

        saveButton: "create-client-save-button",

        clientDocumentInput: "document",

        clientNameInput: "create-client-name-input",

        clientEmailInput: "create-client-email-input",

        clientPhoneInput : "create-client-phone-input",

        clientAddressState: "create-client-address-state-input",

        clientAddressPostalCode: "create-client-address-postal-code-input",

        clientAddressCity: "create-client-address-city-input",

        clientAddressNumber: "create-client-address-number-input",

        clientAddressStreet: "create-client-address-street-input",

        clientAddressComplement: "create-client-address-complement-input",

        clientAddressDistrict: "create-client-address-district-input",
    },

    salesPerson: {
        nameInput: "salesperson-name-input",
        emailInput: "salesperson-email-input",
        phoneInput: "salesperson-phone-input",
        documentInput: "salesperson-document-input",
        passwordInput: "salesperson-password-input",
        createButton: "salesperson-create-button"
    },

    correctionLetter: {

        correctionLetterIcon: "correction-letter-icon",

        correctionLetterTextInput: "correction-letter-text-input",

        postCorrectionLetter: "correction-letter-post-button"
    },

    downloadNfe: {

        downloadButton: 'download-nfe-button'
    },

    certificateRegistration: {

        registerCertificate: "register-digital-certificate-button",

        certificatePassword: "register-digital-certificate-password",

        certificateUpload: "register-digital-certificate-upload",

        certificateSave: "register-digital-certificate-save"
    },

    emitNfe: {
        clientSelect: "emit-nfe-client-selection-button",
        
        clientSearchButton: "emit-nfe-client-search-button",

        clientSelectNextButton: "emit-nfe-next-page-button",

        clientSelectPreviousButton: "emit-nfe-previous-page-button",

        productSelect: "emit-nfe-product-select",

        productSearch: "emit-nfe-product-search",

        nextPageButton: "emit-nfe-next-page-button",

        previousPageButton: "emit-nfe-previous-page-button",

        addPaymentButton: "emit-nfe-add-payment-button",

        emit: "emit-nfe-emit-nfe"
    },

    emitNfse: {
        nextStepButton: "emitNfse-next-step-button",
    },

    report: {
        
        sales:{
            openFilter: "report-sales-filters-open-sales-filters",

            code: "report-sales-filters-code",

            status: "report-sales-filters-status",

            client:"report-sales-filters-client",

            salesPerson: "report-sales-filters-sales-person",

            sellsBetween: "report-sales-filters-sells-between",

            sellsBetweenTodayButton: "report-sales-filters-sells-today-button",

            sellsBetweenThisMonthButton: "report-sales-filters-sells-this-month-button",

            applyFiltersButton: "report-sales-filters-apply-filters"
        }
    },

    pos: {
        searchBar: "input-search-product",

        confirmButton: "pos-confirm-button",


    },

    client: {

        addclient: "add-client-button"

    },
}

export { mapTest }


// WEBPACK FOOTER //
// ./src/components/pages/products/map.test.js